(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("axios"));
	else if(typeof define === 'function' && define.amd)
		define(["axios"], factory);
	else if(typeof exports === 'object')
		exports["vform"] = factory(require("axios"));
	else
		root["vform"] = factory(root["axios"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_21__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition